import React from "react";
import { Chat, Phone, Email, LocationOn, Schedule, ArrowForward } from "@material-ui/icons";
import { Button } from "@material-ui/core";
import { Link } from 'react-router-dom';
import Configs from "../../Assets/editable-stuff/configurations.json";

const Footer = () => {
  const services = [
    { name: "Information Technology", path: "/it" },
    { name: "Websites & Apps", path: "/web-app" },
    { name: "Automation", path: "/automation" }
  ];

  const quickLinks = [
    { name: "How To Pay", path: "/how-to-pay" },
    { name: "Become a Developer", path: "/become-a-developer" },
    { name: "Terms & Conditions", path: "/terms-and-conditions" }
  ];

  return (
    <footer className="footer-modern">
      {/* Main Footer Content */}
      <div className="footer-main">
        <div className="footer-container">
          {/* Brand Column */}
          <div className="footer-brand">
            <h2 className="footer-logo">NeedForGeeks</h2>
            <p className="footer-tagline">
              Professional tech services for homes and businesses.
              Proudly serving New York for over 5 years.
            </p>
            <div className="footer-contact-info">
              <div className="contact-item">
                <LocationOn className="contact-icon" />
                <span>New York, NY</span>
              </div>
              <div className="contact-item">
                <Schedule className="contact-icon" />
                <span>24/7 Support Available</span>
              </div>
            </div>
          </div>

          {/* Services Column */}
          <div className="footer-column">
            <h3 className="footer-heading">Services</h3>
            <ul className="footer-links">
              {services.map((service, index) => (
                <li key={index}>
                  <Link to={service.path} className="footer-link">
                    <ArrowForward className="link-arrow" />
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links Column */}
          <div className="footer-column">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-links">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link to={link.path} className="footer-link">
                    <ArrowForward className="link-arrow" />
                    {link.name}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href="https://geekvitations.needforgeeks.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-link"
                >
                  <ArrowForward className="link-arrow" />
                  Invitations
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div className="footer-column footer-contact">
            <h3 className="footer-heading">Get In Touch</h3>
            <p className="footer-phone">(929) 330-4724</p>
            <div className="footer-buttons">
              <Button
                className="footer-btn"
                variant="contained"
                startIcon={<Phone />}
                href={"tel: " + Configs.PhoneNumber}
              >
                Call
              </Button>
              <Button
                className="footer-btn footer-btn-outline"
                variant="outlined"
                startIcon={<Chat />}
                href={"sms: " + Configs.PhoneNumber + "&body=" + Configs.generalTemplate}
              >
                Text
              </Button>
              <Button
                className="footer-btn footer-btn-outline"
                variant="outlined"
                startIcon={<Email />}
                href={"mailto: " + Configs.EmailAddress + "?subject=" + Configs.generalSubject + "&body=" + Configs.generalTemplate}
              >
                Email
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-container">
          <p className="copyright">
            &copy; 2026 NeedForGeeks. All rights reserved.
          </p>
          <a
            href="https://github.com/NeedForGeeks"
            target="_blank"
            rel="noopener noreferrer"
            className="github-link"
          >
            Built with <span className="heart">♥</span> by NeedForGeeks
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
